import { format } from "@hejdoktor/resx-compiler"
export { format }

export const R = {
	"Name1": "this is my long string",
	"Bitmap1": "[base64 mime encoded serialized .NET Framework object]",
	"Icon1": "[base64 mime encoded string representing a byte array form of the .NET Framework object]",
	"CaregiverChat_ConnectionLost_Message": "Vent venligst mens vi prøver at genoprette forbindelsen eller prøv at genindlæse siden.",
	"CaregiverChat_MessageList_NewMessagePlaceholder": "Skriv besked",
	"CaregiverChat_MessageList_SendButton": "Send",
	"CaregiverChat_MessageList_Title": "Chat",
	"CaregiverChat_OnDutyList_NoCaregiversLabel": "Der er ingen behandlere på vagt i dag",
	"CaregiverChat_OnDutyList_Title": "Behandlere på vagt i dag",
	"CprRequired": "CPR skal udfyldes",
	"Close": "Luk",
	"FieldRequired": "Venligst udfyld felt",
	"EmailRequired": "E-mail skal udfyldes",
	"PhoneNumberRequired": "Angiv venligst telefonnummer. Så kan vi få fat på dig, hvis teknikken driller.",
	"ErrorOccured": "Der opstod en fejl. Prøv venligst igen, eller kontakt os hvis problemet fortsætter.",
	"ErrorRate": "Der opstod en fejl. Kunne ikke gemme rating. Prøv venligst igen, eller kontakt os hvis problemet fortsætter.",
	"InvalidBirthdate": "Ugyldig fødselsdato (dd.mm.åååå)",
	"BirthdateToOld": "Beklager, denne funktionalitet er kun for børn under 18 år. Voksne skal logge ind med deres eget MitID for at bestille en konsultation.",
	"BirthdateToYoung": "Beklager, denne funktionalitet er kun for voksne over 18 år. Børn skal oprettes under menuen \"Børn under 18 år\" på profilsiden.",
	"InvalidName": "Det ligner ikke et fuldt navn. Prøv venligst igen.",
	"InvalidEmail": "E-mailen er ugyldig.",
	"RequirePaymentText": "Jeg er opmærksom på at denne konsultation kræver betaling",
	"ThankYouForRating": "Tak for din tilbagemelding",
	"PartnerEmailRequired": "Familiemedlems e-mail skal udfyldes",
	"PartnerNameRequired": "Familiemedlems navn skal udfyldes",
	"PartnerCprRequired": "Familiemedlems CPR-nummer skal udfyldes",
	"Active": "Aktiv",
	"Invited": "Inviteret",
	"NoPartner": "Ingen partner",
	"AlreadyHasPartner": "Patient har allerede en partner",
	"EmailAlreadyExist": "Emailen eksisterer allerede i systemet",
	"DomainRequired": "Domæne skal udfyldes",
	"FormInvalidValue": "Formularen indeholder ugyldige værdier",
	"ValidDomain": "Gyldigt domænenavn bør starte med '@' (f.eks. @yahoo) Eller gyldig email adresse (f.eks. Company@yahoo.com)",
	"ErrorDeletingDoctor": "Der opstod en fejl under sletning af behandleren",
	"ErrorGettingDoctors": "Der opstod en fejl under hentning af behandlere",
	"ErrorGettingFeedbackResponse": "Der opstod en fejl under hentning af feedback",
	"DoctorEmailAlreadyExist": "En bruger med samme email er allerede oprettet i systemet. Prøv venligst igen med en anden email.",
	"ErrorNewDoctor": "Der opstod en fejl under oprettelse af ny behandler",
	"UserEmailRequired": "Email skal udfyldes",
	"UserPhoneRequired": "Telefonnummer skal udfyldes",
	"UserRoleRequired": "Brugerrolle skal udfyldes",
	"FullNameRequired": "Navn skal udfyldes",
	"ErrorDeletePartner": "Der opstod en fejl under sletning af partner",
	"ErrorUpdateProfileData": "Der opstod en fejl under lagring af profildata",
	"InvalidPhoneNumber": "Ugyldigt telefonnummer",
	"PhoneCallViewModel_ViewIsClosing": "Kaldet afsluttes når denne dialog bliver lukket",
	"ErrorGettingPrices": "Der opstod en fejl under hentning priser",
	"ErrorUpdatePrice": "Der opstod en fejl under opdatering pris",
	"Child": "barn",
	"Partner": "partner",
	"ErrorPatients": "Der opstod en fejl under hentningen af tilmeldte patienter",
	"ValidateCprInvalidCpr": "Please enter a valid CPR number. The CPR number must be exactly 10-digits long.",
	"Friday": "Fredag",
	"Monday": "Mandag",
	"Saturday": "Lørdag",
	"Sunday": "Søndag",
	"Thursday": "Torsdag",
	"Tuesday": "Tirsdag",
	"Wednesday": "Onsdag",
	"ErrorDeleteAccount": "Der opstod en fejl under sletning af konto",
	"ErrorInvitePartner": "Der opstod en fejl i forbindelse med invitationen af familiemedlemmet",
	"ErrorCallQualityFeedback": "Kunne ikke gemme din feedback",
	"Tomorrow": "I morgen",
	"ActiveConsultationTimeFormat": "{0} kl. HH:mm",
	"ActiveConsultationDateTimeFormat": "d. MMMM kl. HH:mm",
	"PleaseEnterFullName": "Indtast venligst det fulde navn",
	"CouldNotCreateChild": "Kunne ikke oprette barn: ",
	"Profile_AddChild": "Tilføj barn",
	"Profile_EditChild": "Rediger barn",
	"Darn": "Øv!",
	"SorryForYourConcerns": "Vi er kede af det ikke gik som forventet. Det vil være en stor hjælp for os, hvis du vil forklare hvad der var galt.",
	"ThankYou": "Tak!",
	"ImproveOurselves": "Vi vil altid gerne forbedre os. Fortæl os gerne hvordan.",
	"Great": "Dejligt!",
	"BigHelp": "Det vil være en stor hjælp, hvis du vil sætte et par ord på din oplevelse.",
	"dateFnsShortDateFormat": "d. MMM yyyy",
	"dateFnsTimeFormat": "HH.mm",
	"dateFnsTodayRelativeFormat": "'I dag kl.' HH:mm",
	"dateFnsTomorrowRelativeFormat": "'I morgen kl.' HH:mm",
	"ProfileConfirmEditKid": "Gem",
	"ClockValidatorError": "Uret på dit apparat går forkert. Indstil det venligst for at være sikker på, at Hejdoktor fungerer.",
	"dateFnsLongDateFormat": "d. MMMM yyyy",
	"dateFnsLongDateTimeFormat": "d. MMMM yyyy 'kl.' HH.mm",
	"dateFnsShortDateTimeFormat": "d. MMM yyyy HH.mm",
	"NameRequired": "Indtast venligst dit fulde navn",
	"Settings": "Indstillinger",
	"Camera": "Kamera",
	"Microphone": "Mikrofon",
	"Speaker": "Højtaler",
	"Starting": "Starter",
	"Connecting": "Forbinder...",
	"Connected": "Forbundet",
	"Disconnecting": "Afbryder",
	"Disconnected": "Afbrudt",
	"Reconnecting": "Forsøger at forbinde igen",
	"CameraOffTooltip": "Tænd kamera",
	"CameraOnTooltip": "Sluk kamera",
	"VideoLoadingTooltip": "Kamera starter",
	"MicrophoneOffTooltip": "Tænd mikrofon",
	"MicrophoneOnTooltip": "Sluk mikrofon",
	"SettingsTooltip": "Indstillinger",
	"EndCall": "Afslut opkald",
	"StartPhoneCall": "Start telefonopkald",
	"StartPhoneCallTooltip": "Opstår der tekniske udfordringer, kan du ringe op til patienten via telefon.",
	"PhoneCallPopupTitleConnecting": "Ringer til patienten",
	"PhoneCallPopupTitleConnected": "Telefonopkald er i gang",
	"PhoneCallPopupDescription": "Du er ved at ringe patienten op via telefon. Du kan stadig benytte video til at vurdere patientens problematik.",
	"PhoneCallPopupEndCallButtonText": "Afbryd telefonopkald",
	"NoTimesAvailable": "Ingen tilgængelige tider",
	"ErrorCancelingConsultation": "Der opstod en fejl under aflysningen af konsultationen",
	"ErrorChangingCaregiver": "Der opstod en fejl under skift af psykologen",
	"ErrorEditingUser": "Der opstod en fejl under redigering af brugeren",
	"Admin": "Admin",
	"CustomerService": "Kundeservice",
	"Doctor": "Psykolog",
	"Visitator": "Visitator"
}